module.exports = __webpack_public_path__ + "img/us-quotation-popup-bg@3x.2dcf65df.png";